import classNames from 'classnames'
import { forwardRef } from 'react'

import type { Props as InputWrapperProps } from '../InputWrapper'
import type { InputHTMLAttributes, ReactNode, ReactElement } from 'react'

import InputWrapper from '../InputWrapper'

import { createUUID } from '~/utils/uuid'

import './styles.scss'

export interface Props
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>,
    Omit<InputWrapperProps, 'children' | 'inputType' | 'size'> {
  className?: string
  icon?: ReactElement
  label?: string
  labelPosition?: 'top' | 'left'
  size?: Exclude<SIZES, 'large'>
  tooltip?: ReactNode
}

const TextInput = forwardRef<HTMLInputElement, Props>(
  (
    { className, icon, iconPosition, id, label, labelPosition, size = 'medium', tooltip, wrapperClassName, ...props },
    ref
  ) => {
    const inputClasses = classNames('text-input', size, { 'with-icon': !!icon })
    const localId = id || createUUID()

    return (
      <InputWrapper
        {...props}
        className={className}
        disabled={props.disabled}
        icon={icon}
        iconPosition={iconPosition}
        inputId={localId}
        label={label}
        labelPosition={labelPosition}
        required={props.required}
        size={size}
        tooltip={tooltip}
        wrapperClassName={wrapperClassName}
      >
        <input {...props} className={inputClasses} id={localId} ref={ref} required={false} />
      </InputWrapper>
    )
  }
)

TextInput.displayName = 'TextInput'

export default TextInput
